import React from 'react';
import { Outlet, useNavigate } from 'react-router-dom';
import AdminHeader from '../layout/AdminHeader';
import AdminSidebar from '../layout/AdminSidebar';
import { useAuthStore } from '@/stores/auth-store';
import { useSidebar } from '@/contexts/SidebarContext';

/**
 * Shell for the admin console (/admin/*, /tutor/*). Mirrors AppLayout's
 * structure but composes the admin-only AdminHeader + AdminSidebar so the admin
 * surface carries none of the learner chrome (notifications, streak, upgrade
 * card, background-generation toasts). Which shell renders is URL-driven — this
 * layout is mounted behind an ADMIN-gated route in App.tsx.
 */
export default function AdminLayout() {
  const [sidebarOpen, setSidebarOpen] = React.useState(false);
  const { isCollapsed, toggleCollapse } = useSidebar();
  const navigate = useNavigate();
  const { user, logout } = useAuthStore();

  const userData = {
    name: user?.name || 'User',
    email: user?.email || '',
    avatar: null,
  };

  const handleLogout = async () => {
    await logout();
    navigate('/login');
  };

  return (
    <div className="min-h-screen bg-gray-50 dark:bg-tutara-dark-mode-bg">
      <AdminHeader
        onMenuClick={() => setSidebarOpen(!sidebarOpen)}
      />

      <div className="flex">
        <AdminSidebar
          isOpen={sidebarOpen}
          isCollapsed={isCollapsed}
          onClose={() => setSidebarOpen(false)}
          onToggleCollapse={toggleCollapse}
          user={userData}
          onLogout={handleLogout}
        />

        <main className={`flex-1 pt-16 transition-all duration-300 overflow-x-hidden ${isCollapsed ? 'lg:pl-16' : 'lg:pl-64'}`}>
          <div className="px-4 sm:px-6 lg:px-8 py-8">
            <Outlet />
          </div>
        </main>
      </div>
    </div>
  );
}
